import React, { useState } from 'react';
import { connect } from 'react-redux';

import clsx from 'clsx';
import { isEmpty } from 'lodash';

import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { TimezoneOffsets } from '../../../helpers/timezones';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as BasAgentActions from '../../../actions/basAgentActions';

import * as classes from './CreateBasAgentModal.module.css';

const CreateBasAgentModal = ({
    activeNavCompany,
    createBasAgent,
    setCreateBasAgentModalOpen,
    ...props
}) => {

    const [agentName, setAgentName] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [timezone, setTimezone] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleCreateIntegration = async () => {
        const agent = {
            name:                agentName,
            serialNumber:        serialNumber,
            driverConfiguration: [],
            timeZone:            timezone.name,
            timeZoneOffset:      timezone.offSet
        };

        setIsLoading(true);
        await createBasAgent(activeNavCompany.id, agent);
        setIsLoading(false);
        setCreateBasAgentModalOpen(false);
    };

    const handleSerialNumberChange = event => {
        setSerialNumber(event.target.value);
    };

    const handleNameChange = event => {
        setAgentName(event.target.value);
    };

    const handleTimezoneChange = event => {
        setTimezone(event.target.value);
    };

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 500
            },
        },
    };

    return (
        <BobModal
            title={'New Agent'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setCreateBasAgentModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.BodyContainer}>
                    <TextField
                        id="standard-required"
                        label={<span>Agent Configuration Name<span className={classes.Required}> *</span></span>}
                        placeholder="Enter"
                        value={agentName}
                        onChange={handleNameChange}
                        size="small"
                        inputProps={{
                            style: { fontSize: 14 }
                        }}
                        InputLabelProps={{
                            className: classes.NameLabel
                        }}
                        className={classes.NameInput}
                        variant="outlined"
                    />
                    <TextField
                        id="standard-required"
                        label={'Serial Number'}
                        placeholder="Enter"
                        value={serialNumber}
                        onChange={handleSerialNumberChange}
                        size="small"
                        inputProps={{
                            style: { fontSize: 14 }
                        }}
                        InputLabelProps={{
                            className: classes.NameLabel
                        }}
                        className={classes.NameInput}
                        variant="outlined"
                    />
                    <div className={classes.InfoPanel}>
                        <i className={clsx('fas fa-info-circle', classes.HelpIcon)} />
                        <span className={classes.InfoText}>
                            The Serial Number is unique to your Agent installation.
                            If you have one enter it now, or wait to enter it later.
                            Choose the time zone where the Agent will be installed.
                        </span>
                    </div>
                    <FormControl variant="outlined" size="small" className={classes.Select}>
                        <InputLabel
                            style={{
                                backgroundColor: 'white',
                                paddingRight:    '5px',
                                paddingLeft:     '10px'
                            }}
                        >
                            <span>Time Zone<span className={classes.Required}> *</span></span>
                        </InputLabel>
                        <Select
                            value={timezone}
                            classes={{ root: classes.SelectFont }}
                            MenuProps={MenuProps}
                            onChange={handleTimezoneChange}
                            className={classes.select}
                            inputProps={{
                                name: 'driverType',
                                id:   'driverType'
                            }}
                        >
                            {
                                TimezoneOffsets.map((zone, index) =>
                                    <MenuItem
                                        key={index}
                                        value={zone}
                                    >
                                        <ListItemText primary={zone.name} />
                                    </MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                <div className={classes.ButtonsContainer}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setCreateBasAgentModalOpen(false)}
                        className={classes.CancelButton}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        disabled={isEmpty(agentName) || isEmpty(timezone)}
                        onClick={() => handleCreateIntegration()}
                        className={isLoading || isEmpty(agentName) || isEmpty(timezone) ? classes.DisabledButtons : classes.Buttons}
                        label={'Create'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
});

const mapDispatchToProps = {
    ...BasAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateBasAgentModal);
